/* Wrought gothic accents: turns the sword line under headings into wrought-iron scrollwork.
   Keeps the same draw-in animation (each path uses pathLength="1"). Styles live in snippets/wrought-gothic.liquid. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  // 400 x 24, centre line y = 12. Left half is drawn, right half is its mirror.
  var LEFT = [
    'M10 12 L146 12',                                             // rail
    'M4 12 L8 9.5 L12 12 L8 14.5 Z',                              // end finial
    'M146 12 C158 12 164 3.5 173 3.5 C180 3.5 182 8.5 178.5 10 C175.5 11.2 173.5 8 176 6.6', // upper scroll
    'M146 12 C158 12 164 20.5 173 20.5 C180 20.5 182 15.5 178.5 14 C175.5 12.8 173.5 16 176 17.4', // lower scroll
    'M180 12 L187 12'                                             // collar
  ];
  function mirror(d) {
    return d.replace(/(-?\d+(?:\.\d+)?) (-?\d+(?:\.\d+)?)/g, function (m, x, y) {
      return (400 - parseFloat(x)).toFixed(1).replace(/\.0$/, '') + ' ' + y;
    });
  }
  var CENTER = [
    'M188 12 L200 0.5 L212 12 L200 23.5 Z',   // lozenge
    'M194 12 L200 6 L206 12 L200 18 Z',       // inner lozenge
    'M200 6 L200 18 M194 12 L206 12'          // cross
  ];
  var PATHS = LEFT.concat(LEFT.map(mirror), CENTER);

  function iron(svg) {
    if (!svg || svg.dataset.wrIron) return;
    svg.dataset.wrIron = '1';
    svg.setAttribute('viewBox', '0 0 400 24');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    PATHS.forEach(function (d) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      p.setAttribute('pathLength', '1');
      svg.appendChild(p);
    });
    svg.classList.add('wr-iron');
  }

  function sweep(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('svg.wr-blade, svg.wr-teaser__blade, svg.wr-mark__blade'), iron);
  }

  function initHome() {
    var main = document.querySelector('main[data-template="index"]');
    if (!main) return;
    var hero = main.querySelector(':scope > .shopify-section');
    // Phones: stop the hidden desktop video from downloading too (the visible one is untouched).
    if (hero && window.innerWidth < 750) {
      Array.prototype.forEach.call(hero.querySelectorAll('video'), function (v) {
        if (v.offsetWidth) return;
        v.removeAttribute('autoplay');
        try { v.pause(); } catch (e) {}
        Array.prototype.forEach.call(v.querySelectorAll('source'), function (s) { s.remove(); });
        v.removeAttribute('src');
        try { v.load(); } catch (e) {}
      });
    }
    var pl = main.querySelector('[id$="__product_list_themegen"]');
    if (pl && !pl.querySelector('.wr-pl-head')) {
      var trust = document.createElement('div');
      trust.className = 'wr-trust';
      trust.innerHTML = '<span class="wr-trust__item">Made to order</span>' +
        '<span class="wr-trust__item">Ships in 2&ndash;5 business days</span>' +
        '<span class="wr-trust__item">Free US shipping over $100</span>' +
        '<a class="wr-trust__quiz" href="/pages/find-your-piece">Not sure? Find your piece &rarr;</a>';
      var hd = document.createElement('div');
      hd.className = 'wr-pl-head';
      hd.innerHTML = '<span class="wr-pl-head__eb">Wrought / The Essentials</span><h2 class="wr-pl-head__t">Start here</h2><a class="wr-pl-head__all" href="/collections/clothing">Shop all &rarr;</a>';
      pl.insertBefore(hd, pl.firstChild);
      pl.insertBefore(trust, hd);
    }
  }

  function start() {
    try { initHome(); } catch (e) {}
    sweep();
    // "Shop now" buttons point at /collections/all, which includes the flag and other non-clothing items.
    Array.prototype.forEach.call(document.querySelectorAll('main a[href="/collections/all"], main a[href^="/collections/all?"]'), function (a) {
      a.setAttribute('href', '/collections/clothing');
    });
    var main = document.querySelector('main') || document.body;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('svg.wr-blade')) iron(n); else sweep(n);
        });
      });
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
